import { render, staticRenderFns } from "./ApproverSettingsTable.vue?vue&type=template&id=311c869c&"
import script from "./ApproverSettingsTable.vue?vue&type=script&lang=js&"
export * from "./ApproverSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports